import { useEffect, useState } from 'react';
import HelperFunctions from '../helpers/HelperFunctions';
import { TeamSVG } from './SvgIcons';
import PlayerIcon from './PlayerIcon';

export default function PlayerCardTypeahead({ data, status, onSelect, noImg }) {
    const { firstNameExtracted } = HelperFunctions();
    const { first_name, last_name, currentTeam, positions, following, image } = data;
    const team_image = data.team?.image || data.team_image;

    const fullName = `${first_name || ''} ${last_name || ''}`.trim();

    // Normalize following value (true/false or 1/0)
    const normalizeFollowing = (following) => {
        if (typeof following === 'boolean') {
            return following;
        }
        return following === 1;
    };

    const [isFollowed, setIsFollowed] = useState(normalizeFollowing(following));

    const handleFollowClick = () => {
        if (!isFollowed) {
            setIsFollowed(true);
            onSelect(data);
        }
    };

    useEffect(() => {
        setIsFollowed(normalizeFollowing(data.following));
    }, [data]);

    return (
        <div className="px-2half py-3 d-flex justify-content-between align-items-center">

            <div className={`d-flex ${!noImg ? 'align-items-center' : 'flex-column align-items-start'} me-1`}>
                {!noImg && (
                    <PlayerIcon image={image} size='disc-65' fullName={fullName} playerFollowing={isFollowed} showPlayerFollowing={true} />
                )}
                <div className="d-flex flex-column align-items-start  ps-2">
                    <p className="d-block mb-0 fw-normal text-center small text-decoration-none text-white">
                        {firstNameExtracted(first_name) || ''}{' '}
                        <strong className="fw-semi-bold">{last_name || ''}</strong>
                    </p>
                    {!status && positions.length > 0 && (
                        <p className="d-block mb-0 extra-small text-wrap text-neutral-gray-700 text-start">
                            {positions.map(position => position?.positionName).join('/ ')}
                        </p>
                    )}
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <div className='center-content rounded-2 rounded-top-start-0 rounded-top-end-0'>
                            {currentTeam ? (
                                team_image ? (
                                    <img className="object-fit-cover disc-35 rounded-circle me-2" src={team_image} alt={currentTeam || "Team"} />
                                ) : (
                                    <TeamSVG />
                                )
                            ) : null}
                            <p className="mb-0 small">{currentTeam || ""}</p>
                        </div>
                    </div>
                </div>
            </div>
            {status && (
                <div
                    className={`btn text-center rounded-pill badge rounded-pill border-1 small fw-normal py-1 px-3 ${isFollowed
                        ? 'text-neutral-gray-800 bg-zero-dark-300'
                        : 'text-crayola-red-300 border border-crayola-red-300'
                        }`}
                    onClick={!isFollowed ? handleFollowClick : undefined}
                >
                    {isFollowed ? 'Following' : 'Follow'}
                </div>
            )}
        </div>
    );
}
